import React from "react";

import TwoPanelDialog, { JustifyContent } from "components/TwoPanelDialog";

import Content from "./Content";
import Open from "./Open";
import Title from "./Title";

import { hideRetailZoneInfo, selectRetailZoneInfoIsVisible } from "modules/customer/insights/portfolioNew/areaHealthNew/areaHealthNewSlice";
import { useAppDispatch, useAppSelector } from "store";

const RetailZonesInfo: React.FC = () => {
    const dispatch = useAppDispatch();
    const isVisible = useAppSelector(selectRetailZoneInfoIsVisible);

    const handleClose = () => {
        dispatch(hideRetailZoneInfo());
    };

    return (
        <>
            <Open />
            <TwoPanelDialog
                open={isVisible}
                onClose={handleClose}
                leftPanelTitle={<Title />}
                leftPanelContent={<></>}
                leftPanelActions={<></>}
                leftPanelActionsJustifyContent={JustifyContent.SpaceBetween}
                rightPanelContent={<Content />}
            />
        </>
    );
};

export default RetailZonesInfo;
